import React from 'react'
import { FaXmark } from 'react-icons/fa6';
import Modal from "react-modal";
const AppointmentModal = ({ isOpen, data, toggleMenu }) => {
    // console.log(data);

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={toggleMenu}
            className={`absolute flex flex-col min-w-max top-8 right-0 w-48 bg-blue-400 shadow-lg rounded-lg transition-transform duration-300 ease-in-out transform ${isOpen ? "translate-y-0 opacity-100" : "-translate-y-4 opacity-0"
                }`}
            // className="fixed inset-0 flex items-center justify-center overflow-y-auto outline-none"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
        >
            <div className='flex items-center justify-between mt-2 px-4'>
                <div></div>
                <h3 className='text-white text-lg font-bold'>Appointment Details</h3>
                <FaXmark className='text-white cursor-pointer bg-red-500 p-1 rounded-full text-2xl' onClick={toggleMenu} />
            </div>
            <div className="p-4 overflow-x-scroll max-h-[50vh]">
                <table className="min-w-full bg-white border border-gray-300">
                    <thead>
                        <tr className="bg-blue-600 border-b text-white">
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                #
                            </th>
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                Date
                            </th>
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                Time
                            </th>
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                Status
                            </th>
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                Scheduled By
                            </th>
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                Invoice#
                            </th>
                            <th style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                Claim ID
                            </th>
                        </tr>
                    </thead>{" "}
                    <tbody>

                        {Array.isArray(data) && data?.length > 0 && data?.map((row, index) => (
                            <tr
                                key={index + 1}

                            >
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {index + 1}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {row.AppointmentDate}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {row.AppointmentTime}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {row.insurance}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {row.ScheduledBy}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {row?.provider}
                                </td>
                                <td style={{ whiteSpace: "nowrap" }} className="p-2 border-r">
                                    {row?.ClaimID}
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Modal>
    )
}

export default AppointmentModal
